import React, { useState } from 'react';
import SortButton from '../../UI/SortButton';

const ScheduleEmailsTableHeader = () => {

  const [sortedBy, setSortedBy] = useState({
    created: null,
    template_title: null,
    last_triggered: null,
    scheduled_send_time: null,
    is_active: null,
    recurrence_frequency: null,
    recurrence_interval: null,

  });

  return (
    <tr>
      <SortButton
        name="Created Date"
        sortBy="created"
        setSortedBy={setSortedBy}
        sortedBy={sortedBy}
      />
      <SortButton
        name="Template Title"
        sortBy="template_title"
        setSortedBy={setSortedBy}
        sortedBy={sortedBy}
      />
      <SortButton
        name="Interval"
        sortBy="recurrence_interval"
        setSortedBy={setSortedBy}
        sortedBy={sortedBy}
      />
      <SortButton
        name="Frequency"
        sortBy="recurrence_frequency"
        setSortedBy={setSortedBy}
        sortedBy={sortedBy}
      />
      <SortButton
        name="Last Triggered"
        sortBy="last_triggered"
        setSortedBy={setSortedBy}
        sortedBy={sortedBy}
      />
      <SortButton
        name="Next execution time"
        sortBy="scheduled_send_time"
        setSortedBy={setSortedBy}
        sortedBy={sortedBy}
      />
      <SortButton
        name="Status"
        sortBy="is_active"
        setSortedBy={setSortedBy}
        sortedBy={sortedBy}
      />
      <th>
        Actions
      </th>
    </tr>
  )
}

export default ScheduleEmailsTableHeader;